import { useTranslation } from 'react-i18next';
import { ManageSearch as ManageSearchIcon, Settings as SettingsIcon } from '@mui/icons-material';

import { ReactComponent as PriceListSVG } from '@/shared/assets/icons-2.0/shoppingmode.svg';
import { usePermissions } from '@/shared/hooks/useCheckPermissions.ts';
import { useIsPharmacy } from '@/shared/hooks/useIsPharmacy';
import {
  DorimFinancePaths,
  DorimPromoPaths,
  OrdersLinks,
  PriceListsPaths,
  ProductSelectionPaths,
  RequirementsCalculationPaths,
  SettingsPaths,
  SpecialPriceListsPaths,
} from '@/shared/lib/react-router';

import { ReactComponent as CalculateSVG } from './assets/icons/calculate.svg';
import { ReactComponent as CashbackSVG } from './assets/icons/cashback.svg';
import { ReactComponent as DorimFinanceSVG } from './assets/icons/dorim_finance.svg';
import { ReactComponent as OrderApproveSVG } from './assets/icons/order_approve.svg';
import { NavbarBase } from './NavbarBase';
import { NavbarItem } from './NavbarItem';

export const Navbar = () => {
  const { t } = useTranslation('navbar');
  const { can } = usePermissions();
  const isPharmacy = useIsPharmacy();

  const canViewDemandCalculations = can('view', 'demand_calculations');
  const canViewPriceLists = can('view', 'price_lists');
  const canViewLoan = can('view', 'loan');
  const canViewCashbacks = can('view', 'cashbacks');
  const canViewPharmacies = can('view', 'pharmacies');

  return (
    <NavbarBase>
      {canViewDemandCalculations && (
        <NavbarItem
          iconComponent={CalculateSVG}
          to={RequirementsCalculationPaths.ROOT_PATH}
          title={t('requirements-calculation')}
        />
      )}
      <NavbarItem
        iconComponent={ManageSearchIcon}
        to={ProductSelectionPaths.ROOT_PATH}
        title={t('product-selection')}
      />
      <NavbarItem iconComponent={OrderApproveSVG} to={OrdersLinks.root} title={t('orders')} />
      {canViewPriceLists && (
        <NavbarItem iconComponent={PriceListSVG} to={PriceListsPaths.ROOT} title={t('price-lists')} />
      )}
      {isPharmacy && (
        <NavbarItem iconComponent={PriceListSVG} to={SpecialPriceListsPaths.ROOT} title={t('special-price-lists')} />
      )}
      {canViewLoan && (
        <NavbarItem iconComponent={DorimFinanceSVG} to={DorimFinancePaths.ROOT_PATH} title={t('dorim-finance')} />
      )}
      {canViewCashbacks && (
        <NavbarItem iconComponent={CashbackSVG} to={DorimPromoPaths.ROOT_PATH} title={t('dorim-promo')} />
      )}
      <NavbarItem
        iconComponent={SettingsIcon}
        to={SettingsPaths.ROOT}
        title={t('settings.title')}
        submenu={[
          {
            to: SettingsPaths.DISTRIBUTORS,
            title: t('settings.submenu.distributors'),
          },
          {
            to: SettingsPaths.EXPIRY_DATES,
            title: t('settings.submenu.expiry-dates'),
          },
          ...(canViewPharmacies
            ? [
                {
                  to: SettingsPaths.USERS,
                  title: t('settings.submenu.users'),
                },
                {
                  to: SettingsPaths.PHARMACIES,
                  title: t('settings.submenu.pharmacies'),
                },
              ]
            : []),
        ]}
      />
    </NavbarBase>
  );
};
